export const base = 'front-web';
export const appName = 'front-web';
export const authToken = 'front-token';
export const authId = 'front-web-id';
export const authMobile = 'front-mobile';
export const authEmail = 'front-auth-email';
export const currentUser = 'front-current-user';

// axios请求缓存
export const MAX_AGE = 5000;
